import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2, jkLib, dateFormatter, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Stkmf } from '../entity/Stkmf-angular';


@Injectable({
  providedIn: 'root'
})
export class StkmfServicePkg extends JkEntityV2 {


  constructor() {
    super();
    this.linkMasterFields = 'MF001=ME001';
    this.defaultItem = new Stkmf();
    this.entityType.type = EntityType.detail;
    this.columnLabel = {
      COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數',
      MF001: '群組代號', MF002: '股票代號', MF003: '排序碼', MF004: '更新碼', MF005: '備註', MF006: '更新日期'
    };

    this.fieldNames = 'MF001,MF002,MF003,MF004,MF005,MF006';
    this.fieldLengths = { MF001: 6, MF002: 10, MF003: 4, MF004: 1, MF005: 255, MF006: 8 };
    this.columnDefs = [
      { field: "MF002", headerName: "股票代號", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "MF003", headerName: "排序碼", headerTooltip: "", width: 102, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MF004", headerName: "更新碼", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "MF005", headerName: "備註", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "MF006", headerName: "更新日期", headerTooltip: "", width: 120, cellDataType: "text", valueFormatter: dateFormatter, },
    ];
    this.columnDefsVir = [
      { field: "DATEX", headerName: "市價日期", headerTooltip: "", width: 120, cellDataType: "text", },
      { field: "LG005", headerName: "成交張數", headerTooltip: "", width: 158, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "LG006", headerName: "成交量", headerTooltip: "", width: 158, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "LG007", headerName: "開盤價", headerTooltip: "", width: 160, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "LG008", headerName: "最高價", headerTooltip: "", width: 160, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "LG009", headerName: "最低價", headerTooltip: "", width: 160, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "LG010", headerName: "收盤價", headerTooltip: "", width: 160, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "LG024", headerName: "漲跌", headerTooltip: "", width: 160, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "LG025", headerName: "SMA5", headerTooltip: "", width: 160, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MF002C", headerName: "名稱", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "STKMA006", headerName: "摘要", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "STKMA028", headerName: "XQ股票代號", headerTooltip: "", width: 198, cellDataType: "text", },
      { field: "STKMA047", headerName: "群組", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
    ];
    this.tableName = 'STKMF';
    this.isSys = false;
    this.sqlSelect = `SELECT STKMF.*,MA002 AS MF002C,MA006 AS STKMA006,MA028 as STKMA028,
    MA047 AS STKMA047,
    MA030 AS DATEX,LG005,LG006,LG007,LG008,LG009,
	LG010,LG024,LG025
FROM STKMF
LEFT JOIN STKMA ON MA001=MF002
LEFT JOIN STKLG ON LG004=MA001 AND LG002='日線' AND LG001=MA030
` ;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1`;
    this.sqlOrderDefault = ` ORDER BY MF001,MF002`;
    this.keyFields = ['MF001', 'MF002'];
    this.url = '/db/crud';
    this.rememberFields = [];
    this.requiredFields = ['MF001', 'MF002'];
    this.seqField = '';
    this.seqFieldLength = 4;
  }
  override async validateItem(item: Stkmf): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

override async newRecord(newItem: Stkmf): Promise<Stkmf> {
    await super.newRecord(newItem);
    return newItem;
  }



  async MF002Change(value: any) { // 股票代號
    let bool = await this.advCheck('MF002', this.item, 'STKMA', 'V01', 'MF002C', [this.item.MF002], 'E', '股票代號錯誤.');
  }

}

// 客製開始====================================================
